import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityPriorityListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Level', value: 'level' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/priority/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityPriority']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityPriorityListDetails;